import { getTimezone } from '../../utils/date.js';
import 'date-fns';

const subscribeEmailToNewsletter = async (region, locale, catalogId, refURL, currURL, emailId, source, accorSubscribe) => {
    const data = JSON.stringify({
        action: 'add',
        data: {
            region,
            timeZone: getTimezone(),
            language: locale.toUpperCase(),
            method: 'API',
            website: catalogId,
            // For testing locally use 'https://dev-eu.shopmarriott.com/' as refURL value
            refURL,
            // For testing locally use 'https://dev-eu.shopmarriott.com/' as currURL value
            currURL,
            emailId,
            source,
            name: '',
            ...(accorSubscribe && { subscribedList: accorSubscribe }),
        },
    });
    try {
        const response = await fetch(!accorSubscribe ? process.env.NEXT_PUBLIC_SF_API : process.env.NEXT_PUBLIC_SF_API_ACCOR, {
            method: 'POST',
            body: data,
            // For testing locally uncomment the line below
            // headers: { origin: 'https://dev-eu.shopmarriott.com/' },
        });
        if (!response.ok) {
            throw new Error(`Error subscribing email to newsletter: ${response.statusText}`);
        }
        return await response.json();
    }
    catch (error) {
        throw new Error(`Error subscribing email to newsletter: ${error}`);
    }
};

export { subscribeEmailToNewsletter };
//# sourceMappingURL=index.js.map
